export const KYCConstants = {
    GET_KYC_REQUEST: 'GET_KYC_REQUEST',
    GET_KYC_SUCCESS: 'GET_KYC_SUCCESS',
    GET_KYC_ERROR: 'GET_KYC_ERROR',

    POST_KYC_REQUEST: 'POST_KYC_REQUEST',
    POST_KYC_SUCCESS: 'POST_KYC_SUCCESS',
    POST_KYC_ERROR: 'POST_KYC_ERROR',
};